<template>
  <div
    v-if="node?.displayName"
    class="overflow-hidden d-flex flex-fill justify-center align-center"
    :class="contentClass"
  >
    <v-icon start>
      <NodeIcon
        :mime-type="node.mimeType"
        :name="node.name"
        :type="node.type"
      />
    </v-icon>
    <DeepTextTruncateMiddle :text="node.displayName" />
  </div>
</template>

<script lang="ts" setup>
import { DeepTextTruncateMiddle } from '@deepcloud/deep-ui-lib'
import NodeIcon from '@/components/node/NodeIcon.vue'
import type { Node } from '@deepcloud/api-deep-box'

withDefaults(
  defineProps<{
    node?: Pick<Node, 'displayName' | 'mimeType' | 'name' | 'type'> | null
    contentClass?: string
  }>(),
  {
    node: null,
    contentClass: undefined,
  },
)
</script>
